export default __webpack_public_path__ + "static/media/howPage-whyTab.edaf7e1b.svg";